import { Injectable } from '@angular/core';
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { HttpClient } from '@angular/common/http';
import { HttpClientAbstract } from 'src/app/shared/service/http-client-abstract';
import { Observable, Subject } from 'rxjs';
import { SearchTag } from '../model/search-tag.model';

@Injectable({
  providedIn: 'root'
})
export class SearchTagService extends HttpClientAbstract {
  constructor(header: HttpHeaderService, http: HttpClient) {
    super(header, http);
  }

  // subject関連
  public searchTagListSubject = new Subject<any>();
  public searchTagListState = this.searchTagListSubject.asObservable();

  public getSearchTags(params): Observable<any> {
    return super.requestGet('api/v1/search_tags', params);
  }

  public createSearchTag(params): Observable<any> {
    return super.requestPost('api/v1/search_tag/create', params);
  }

  public deleteSearchTag(params): Observable<any> {
    return super.requestPost('api/v1/search_tag/delete', params);
  }

  public updateLastUsedTime(params): Observable<any> {
    return super.requestPost('api/v1/search_tag/update_last_used_time', params);
  }

  public getActivatedTagIds(searchTags: Array<SearchTag>): Array<number> {
    const activatedTags = searchTags.filter(
      searchTag => searchTag.is_activated === true
    );
    const activatedTagIds = activatedTags.map(activatedTag => activatedTag.id);
    return activatedTagIds;
  }
}
